import React, { CSSProperties } from "react"
import { EmbedScript } from "."

export interface ReviewWidgetProps {
  // This property is required in order to be able to use styled component on the widget
  className?: string
  merchantId: string
  style?: CSSProperties
}

export const ReviewWidget = ( { className, merchantId, style }: ReviewWidgetProps ) => (
  <EmbedScript src={ `https://quick-feedback.co/reviews-widget/widget.js?merchant_id=${ merchantId }` }>
    <div id="quick-feedback-reviews-widget" className={ className } style={ { ...style } }/>
  </EmbedScript>
)
